module.exports = __webpack_public_path__ + "img/pappyon-icon.786cee10.svg";